import { StatFilter, StatFilterType } from "../../../compounds/EliasStatsFilter/filter-stats-utils";
import { FinderSelectOptionType } from "../../../compounds/FastFilters/constants";

export const PAGE_TITLE = 'NBA Team Runs Finder';
export const PAGE_SUBTITLE =
  'Search the most complete and accurate NBA database for team runs.';

export const runOptions: FinderSelectOptionType[] = [
  { id: 'none', label: 'Any' },
  { id: 'start', label: 'To Start Game' },
  { id: 'end', label: 'To End Game' },
];

export const DEFAULT_RUN_OPTION = runOptions[0].id;

export const groupByOptions: FinderSelectOptionType[] = [
  { id: 'none', label: 'None' },
  { id: 'team', label: 'Team instances' },
  { id: 'team-season', label: 'Team within a season' },
  { id: 'team-opponent', label: 'Team against an opponent' },
];

export const DEFAULT_GROUP_BY_STATUS = groupByOptions[0].id;

export const statsFilters: StatFilter[] = [
  {
    id: 'points',
    abbr: 'Run',
    name: 'Unanswered Scoring Run (XX-0 run), min 10 PTS',
    year: 1997,
    type: StatFilterType.equality,
  },
]
